import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = React.PropsWithChildren<{
  className?: string;
  id?: string;
}>;
export function Reveal({
  children,
  className,
  id
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} className={className} initial={reduceMotion ? false : {
    opacity: 0,
    y: 22
  }} whileInView={reduceMotion ? undefined : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.12
  }} transition={{
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-170" data-mp="3bjyucwrp1ie0">
      {children}
    </motion.section>;
}